export var MPAEntityType;
(function (MPAEntityType) {
    MPAEntityType["MPA_ENTITY_TYPE_UNSPECIFIED"] = "MPA_ENTITY_TYPE_UNSPECIFIED";
    MPAEntityType["MPA_ENTITY_TYPE_SNAPSHOT"] = "MPA_ENTITY_TYPE_SNAPSHOT";
    MPAEntityType["MPA_ENTITY_TYPE_CLOUD_RESOURCE"] = "MPA_ENTITY_TYPE_CLOUD_RESOURCE";
    MPAEntityType["MPA_ENTITY_TYPE_BACKUP_POLICY"] = "MPA_ENTITY_TYPE_BACKUP_POLICY";
})(MPAEntityType || (MPAEntityType = {}));
